import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface RouteProfileState {
    selectedView: string;
}

const initialState: RouteProfileState = {
    selectedView: 'info',
};

const routeProfileSlice = createSlice({
    name: 'routeProfile',
    initialState,
    reducers: {
        setSelectedView(state, action: PayloadAction<string>) {
            state.selectedView = action.payload;
        },
    },
});

export const { setSelectedView } = routeProfileSlice.actions;
export default routeProfileSlice.reducer;